import MultiGrid from './MultiGrid';

export default MultiGrid;
export { MultiGrid };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/MultiGrid/index.js
// module id = 987
// module chunks = 4